
import { Component, OnInit } from '@angular/core';
import {Confirmation, MenuItem} from 'primeng/api';
import {MessageService} from 'src/app/services/toaster/message.service'
@Component({
  selector: 'bart-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  alertmessage:string=null;
  messageHeader:string="Message"
  showAlert:boolean=false;
  confirmMessage:any=null;
  isConfirmCancelButtonShow:boolean=true;// For Alert wait for ok button Clicked
  genericConfirmation?:Confirmation=null;
  genericMessage:any;
  constructor(private messageService: MessageService) { }

  ngOnInit() {
    this.messageService.currentMessage.subscribe(message => 
      {
       this.messageHeader="Message";
       this.alertmessage = message
       
        if(this.alertmessage!=null && this.alertmessage!=undefined && this.alertmessage.length>2)
        {
          this.showAlert=true;
          this.alertmessage=this.alertmessage.replace(/(?:\r\n|\r|\n)/g, '<br>');
          var arrmsg=this.alertmessage.split(":");
          if(arrmsg!=null && arrmsg!=undefined && arrmsg.length>0 && arrmsg[1]!=undefined && arrmsg[1].length>0)
          {
            this.messageHeader=arrmsg[0];
            this.alertmessage=arrmsg[1];
          }
        }
        else
        {
          this.showAlert=false;
        }
      });
    //#region Confirm Dialog
      this.messageService.getMessage().subscribe(message => { 
        this.messageHeader="Confirmation"
        this.isConfirmCancelButtonShow=true
        this.confirmMessage = message;
        //console.log(this.confirmMessage)
        if(message!=null && message!=undefined )
        {
          console.log(this.confirmMessage)
          let strMessage:string=message.text
          var arrmsg=strMessage.split(":");
          if(arrmsg!=null && arrmsg!=undefined && arrmsg.length>0 && arrmsg[1]!=undefined && arrmsg[1].length>0)
          {
            this.isConfirmCancelButtonShow=false
            this.messageHeader="Success";
            this.confirmMessage.text=arrmsg[1];
          }
          else if(message.text.toString().toLowerCase().indexOf("success:")!=-1)
          {
            this.isConfirmCancelButtonShow=false
            this.messageHeader="Success";
            this.confirmMessage.text=arrmsg[1];
          }
        }
      });  
    //#endregion Confirm Dialog
    //#region Generic Confirm Dialog
    
    this.messageService.getGenericConfirmationMessage().subscribe(message => {
      this.genericConfirmation=null;
      if(message) 
      {
        this.genericConfirmation=message
        this.genericMessage = message.genericMessage;
      }
    });  
  //#endregion Confirm Dialog

  }
  public closeAlertDialog()
  {
    this.messageService.showAlertMessage(null);
    this.showAlert=false;
  }

  
}
